export enum LoginEnums {
  titleForm = 'Login to WOLSAL',
  connected = 'Login',
  email = 'Email address',
  emailRequired = 'Email address is required *',
  password = 'Password',
  passwordRequired = 'Password is required *',
  forgetPassword = 'Forgot password',
}
